<template>
  <div class="main-books-list-info inputs-border">
    <HeaderMenu
      :title="$t('changeBookInfo.title')"
      :routeBackName="routeBackName"
    />
    <div class="book-info-container">
      <!-- <div v-for="(inputData, index) in inputsData" :key="inputData.key">
        <input
          class="input-b-border input-data filled"
          name="s"
          type="text"
          :placeholder="inputData.inputValue"
          v-bind:value="inputData.inputValue"
          @input="setBookDetail($event.target.value, index)"
        />
        <label for="s">
          <span>{{ inputData.label }}</span>
        </label>
      </div> -->

      <!-- === -->

      <div
        class="row"
        v-for="(inputData, index) in inputsData"
        :key="inputData.key"
      >
        <span class="text-gray">
          {{ inputData.label }}
        </span>
        <input
          class="input-b-border input-data filled"
          name="s"
          type="text"
          :placeholder="inputData.inputValue"
          v-bind:value="inputData.inputValue"
          @input="setBookDetail($event.target.value, index)"
        />
      </div>

      <!-- === -->

      <div
        v-for="inputData in listnputsData"
        :key="inputData.key"
        class="text-area-container"
      >
        <p>{{ inputData.label }}</p>
        <textarea
          class="inputs-data-bloke"
          v-model="inputData.inputValue"
          @input="setBookTextArea"
        ></textarea>
      </div>
      <div v-if="hasOriginalBk">
        <p>{{ $t("changeBookInfo.originalBk") }}</p>
        <div class="origin-data">
          <div v-for="originData in originalBk" :key="originData.key">
            <p>{{ originData.label }}</p>
            <p class="origin-val">{{ originData.inputValue }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="change-book-settings-block">
      <button
        :class="{ disable: hasOriginalBk == false }"
        class="btn change-book-settings btn-larg"
        @click="resetBookInfo"
      >
        {{ $t("changeBookInfo.backToOriginalBk") }}
      </button>
      <button
        :class="{ disable: hasChanges == false }"
        class="btn change-book-settings btn-larg"
        @click.stop="setBookInfo"
      >
        {{ $t("changeBookInfo.change") }}
      </button>
    </div>
  </div>
</template>

<script>
const bookAuthors = (book) => {
  let authlen = book.authors_length;
  let ret = [];
  for (let i = 0; i < authlen; i++) {
    // if (book[`authors_${i}_authorTypeId`] == 1) continue;
    const name = book[`authors_${i}_name`];
    ret.push(name);
  }
  return ret;
};

const bookAddNames = (bookData) => {
  let len = bookData.addnames_length;
  let ret = [];
  for (let i = 0; i < len; i++) {
    const name = bookData[`addnames_${i}_name`];
    ret.push(name);
  }
  return ret;
};

import Vue from "vue";
import { fetchBookByID } from "@/services/loadBooksDataFromServer";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      routeBackName: "books",

      //if there is data changes hasOriginalBk=true and
      //show the details of the array of the original book data
      hasOriginalBk: false,
      hasChanges: false,
      inputsData: [
        {
          label: this.$t("changeBookInfo.bookName"),
          inputValue: "",
          key: "name",
        },
        {
          label: this.$t("changeBookInfo.authorName"),
          inputValue: "",
          key: "author",
        },
        {
          label: this.$t("changeBookInfo.yearName"),
          inputValue: "",
          key: "year",
        },
        {
          label: this.$t("changeBookInfo.placeName"),
          inputValue: "",
          key: "place",
        },
      ],
      listnputsData: [
        {
          label: this.$t("changeBookInfo.addBooksName"),
          inputValue: "",
          key: "add_name",
        },
        {
          label: this.$t("changeBookInfo.addAuthorsName"),
          inputValue: "",
          key: "add_author",
        },
      ],
      //array of original book data
      originalBk: [
        {
          label: this.$t("changeBookInfo.bookName"),
          inputValue: "",
          key: "nameOrigin",
        },
        {
          label: this.$t("changeBookInfo.authorName"),
          inputValue: "",
          key: "authorOrigin",
        },
        {
          label: this.$t("changeBookInfo.yearName"),
          inputValue: "",
          key: "yearOrigin",
        },
        {
          label: this.$t("changeBookInfo.placeName"),
          inputValue: "",
          key: "placeOrigin",
        },
        {
          label: this.$t("changeBookInfo.addBooksName"),
          inputValue: "",
          key: "addNameOrigin",
        },
        {
          label: this.$t("changeBookInfo.addAuthorsName"),
          inputValue: "",
          key: "addAuthorOrigin",
        },
      ],
    };
  },
  async created() {
    //get the book object by id(the id from the router)
    let currBook = this.$store.state.menu.currentBookSelected;
    let bookData = JSON.parse(JSON.stringify(this.getBookbyId(currBook)));
    this.hasOriginalBk = bookData.changed === 1;

    // insert into the inputsData array the book data that
    // the user can change
    this.inputsData[0].inputValue = bookData.name;

    this.inputsData[1].inputValue = bookData.authors_0_name;
    this.inputsData[2].inputValue = bookData.fromyear;
    this.inputsData[3].inputValue = bookData.places;
    this.listnputsData[0].inputValue = bookAddNames(bookData).join("\n");
    this.listnputsData[1].inputValue = bookAuthors(bookData)
      .slice(1)
      .join("\n");

    //if there is changes, we will get the original data
    // from database
    //this we use to show the user what he changed and
    //what was the original value
    if (this.hasOriginalBk) {
      let originalBook = await fetchBookByID(currBook);
      //get the original book data that changed
      //and insert tham the book values
      this.originalBk[0].inputValue = originalBook.name;
      this.originalBk[1].inputValue = originalBook.authors.filter(
        (a) => a.authorTypeId === 1
      )[0].name;

      let fromYear = originalBook.fromyear[0].name;
      let toYear = originalBook.toyear[0].name;
      fromYear = fromYear === toYear ? fromYear : fromYear + " - " + toYear;

      this.originalBk[2].inputValue = fromYear;
      this.originalBk[3].inputValue = originalBook.places[0].name;

      this.originalBk[4].inputValue = originalBook.addnames
        .map((n) => n.name)
        .join("\n");
      this.originalBk[5].inputValue = originalBook.authors
        .filter((a) => a.authorTypeId == 2)
        .map((a) => a.name)
        .join("\n");
    }
  },
  computed: {
    ...mapGetters("books", ["getBookbyId"]),

    /*  inputsData() {
      return [
        {
          label: this.$t("changeBookInfo.bookName"),
          inputValue: "",
          key: "name",
        },
        {
          label: this.$t("changeBookInfo.authorName"),
          inputValue: "",
          key: "author",
        },
        {
          label: this.$t("changeBookInfo.yearName"),
          inputValue: "",
          key: "year",
        },
        {
          label: this.$t("changeBookInfo.placeName"),
          inputValue: "",
          key: "place",
        },
      ];
    }, */
    //text area values data- for multiple values in
    //one block
    //addAuthorsName
    /*  listnputsData() {
      return [
        {
          label: this.$t("changeBookInfo.addBooksName"),
          inputValue: "",
          key: "add_name",
        },
        {
          label: this.$t("changeBookInfo.addAuthorsName"),
          inputValue: "",
          key: "add_author",
        },
      ];
    },
    //array of original book data
    originalBk() {
      return [
        {
          label: this.$t("changeBookInfo.bookName"),
          inputValue: "",
          key: "nameOrigin",
        },
        {
          label: this.$t("changeBookInfo.authorName"),
          inputValue: "",
          key: "authorOrigin",
        },
        {
          label: this.$t("changeBookInfo.yearName"),
          inputValue: "",
          key: "yearOrigin",
        },
        {
          label: this.$t("changeBookInfo.placeName"),
          inputValue: "",
          key: "placeOrigin",
        },
        {
          label: this.$t("changeBookInfo.addBooksName"),
          inputValue: "",
          key: "addNameOrigin",
        },
        {
          label: this.$t("changeBookInfo.addAuthorsName"),
          inputValue: "",
          key: "addAuthorOrigin",
        },
      ];
    }, */
    getBookInfo() {
      // return this.getBookbyId(this.$route.params.id); //this.$route.params.id
      return this.getBookbyId(this.$store.state.menu.currentBookSelected); //this.$route.params.id
    },
    fill() {},
  },
  methods: {
    ...mapActions("books", ["setBookData", "resetBookData", "setBookDetails"]),
    //fire message for refreshing books
    showRefreshMessage() {
      return;
      this.$store.dispatch("bookListRefresh/setStatus", "preparing");
    },
    //set book values from input
    setBookDetail(e, i) {
      this.inputsData[i].inputValue = e;
      let book = this.getBookInfo;
      if (
        this.inputsData[0].inputValue !== book.name ||
        this.inputsData[1].inputValue !== book.authors_0_name ||
        this.inputsData[2].inputValue !== book.fromyear ||
        this.inputsData[3].inputValue !== book.places
      ) {
        this.hasChanges = true;
      } else this.hasChanges = false;
    },

    setBookTextArea() {
      let book = this.getBookInfo;
      let namesInputsArray = "";

      if (bookAddNames(book).length > 0) {
        bookAddNames(book).filter((name) => {
          if (namesInputsArray == "") namesInputsArray = name;
          else namesInputsArray = namesInputsArray + "\n" + name;
        });
      }
      let authorsInputsArray = "";
      if (bookAuthors(book).length > 1) {
        let authorsNames = bookAuthors(book).slice(1);
        authorsNames.filter((name) => {
          if (authorsInputsArray == "") authorsInputsArray = name;
          else authorsInputsArray = authorsInputsArray + "\n" + name;
        });
      }
      if (
        this.listnputsData[0].inputValue !== namesInputsArray ||
        this.listnputsData[1].inputValue !== authorsInputsArray
      ) {
        this.hasChanges = true;
      } else this.hasChanges = false;
    },
    //reset book changes to the original book data
    async resetBookInfo() {
      //fire message

      this.showRefreshMessage();
      /*  const notification = {
        type: "success",
        message:
          this.$t("hardReloadMessage.message1") +
          "<br>" +
          this.$t("hardReloadMessage.message2"),
        timeout: 2000,
      };
      this.$notify(notification); */

      let book = this.getBookInfo;
      let originalBook = await fetchBookByID(book.id);

      //get the original book data that changed
      //and insert tham the book values
      Vue.set(this.inputsData[0], "inputValue", originalBook.name);
      this.inputsData[1].inputValue = originalBook.authors.filter(
        (a) => a.authorTypeId == 1
      )[0].name;

      let fromYear = originalBook.fromyear[0].name;
      let toYear = originalBook.toyear[0].name;
      fromYear = fromYear === toYear ? fromYear : fromYear + " - " + toYear;

      this.inputsData[2].inputValue = fromYear;
      this.inputsData[3].inputValue = originalBook.places[0].name;

      this.listnputsData[0].inputValue = originalBook.addnames
        .map((a) => a.name)
        .join("\n");
      this.listnputsData[1].inputValue = originalBook.authors
        .filter((a) => a.authorTypeId == 2)
        .map((a) => a.name)
        .join("\n");
      this.hasOriginalBk = false;
      this.resetBookData(book);
      return;

      // book.authors = book.originalBookInfo.authors;
      for (let i = 0; i < book.authors_length; i++)
        delete book[`authors_${i}_name`];
      for (let i = 0; i < book.originalBookInfo.authors_length; i++) {
        book[`authors_${i}_name`] = book.originalBookInfo[`authors_${i}_name`];
      }
      book.authors_length = book.originalBookInfo.authors_length;

      this.inputsData[1].inputValue = book.originalBookInfo.authors_0_name;
      book.fromyear = book.originalBookInfo.fromyear;
      this.inputsData[2].inputValue = book.originalBookInfo.fromyear;
      book.places = book.originalBookInfo.places;
      this.inputsData[3].inputValue = book.originalBookInfo.places;
      // book.addnames = book.originalBookInfo.addnames;
      for (let i = 0; i < book.addnames_length; i++)
        delete book[`addnames_${i}_name`];
      for (let i = 0; i < book.originalBookInfo.addnames_length; i++) {
        book[`addnames_${i}_name`] =
          book.originalBookInfo[`addnames_${i}_name`];
      }
      book.addnames_length = book.originalBookInfo.addnames_length;

      this.listnputsData[0].inputValue = this.originalBk[4].inputValue;
      this.listnputsData[1].inputValue = this.originalBk[5].inputValue;
      //reset the originalBk inputValue array in data
      this.originalBk.forEach((ob) => {
        ob.inputValue = "";
      });
      //set hasOriginalBk to false so we wont see the origin data array
      //witch is ampty
      this.hasOriginalBk = false;
      //send to the action resetBookData to reset the changes
      //and to delete from the server the user book changes object
      this.resetBookData(book);
    },
    //set book user data changes
    async setBookInfo() {
      let book = this.getBookInfo;
      let bookDetails = {
        bookId: book.id,
        modifications: {
          name: "",
          author: "",
          year: "",
          place: "",
          add_name: [],
          add_author: [],
        },
      };
      this.inputsData.forEach((dt) => {
        switch (dt.key) {
          case "name":
            if (book.name !== dt.inputValue && dt.inputValue !== "") {
              bookDetails.modifications.name = dt.inputValue;
            }
            break;
          case "author":
            if (book.authors_0_name !== dt.inputValue && dt.inputValue !== "") {
              bookDetails.modifications.author = dt.inputValue;
            }
            break;
          case "year":
            if (book.fromyear !== dt.inputValue && dt.inputValue !== "") {
              bookDetails.modifications.year = dt.inputValue;
            }
            break;
          case "place":
            if (book.places !== dt.inputValue && dt.inputValue !== "") {
              bookDetails.modifications.place = dt.inputValue;
            }
            break;
        }
      });
      let hasAddNamesChanges = false;
      let hasAddAuthorsChanges = false;
      let addNamesChanges = [];
      let addAuthorsChanges = [];
      this.listnputsData.forEach((ldt) => {
        if (ldt.key == "add_name") {
          let inputsArray = this.listnputsData[0].inputValue.split("\n");
          for (let i = 0; inputsArray.length > i; i++) {
            if (bookAddNames(book).length > i) {
              if (
                bookAddNames(book)[i].name !== inputsArray[i] &&
                inputsArray[i] !== ""
              ) {
                hasAddNamesChanges = true;
                addNamesChanges.push(inputsArray[i]);
              } else {
                addNamesChanges.push(bookAddNames(book)[i].name);
              }
            } else {
              if (inputsArray[i] !== "") {
                hasAddNamesChanges = true;
                addNamesChanges.push(inputsArray[i]);
              }
            }
          }
          if (hasAddNamesChanges)
            bookDetails.modifications.add_name = addNamesChanges;
          //
        }
        if (ldt.key == "add_author") {
          let inputsArray = this.listnputsData[1].inputValue.split("\n");
          for (let i = 0; inputsArray.length > i; i++) {
            if (
              bookAuthors(book).length > i + 1 &&
              bookAuthors(book).length > 1
            ) {
              if (
                bookAuthors(book)[i + 1].name !== inputsArray[i] &&
                inputsArray[i] !== ""
              ) {
                hasAddAuthorsChanges = true;
                addAuthorsChanges.push(inputsArray[i]);
              } else {
                addAuthorsChanges.push(bookAuthors(book)[i + 1].name);
              }
            } else {
              if (inputsArray[i] !== "") {
                hasAddAuthorsChanges = true;
                addAuthorsChanges.push(inputsArray[i]);
              }
            }
          }
          if (hasAddAuthorsChanges)
            bookDetails.modifications.add_author = addAuthorsChanges;
        }
      });

      //fire message
      this.showRefreshMessage();
      /*  const notification = {
        type: "success",
        message:
          this.$t("hardReloadMessage.message1") +
          "<br>" +
          this.$t("hardReloadMessage.message2"),
        timeout: 2000,
      };
      this.$notify(notification); */

      this.setBookDetails(bookDetails);
      //if there is changes, we will get the original data
      // from database
      //this we use to show the user what he changed and
      //what was the original value
      let originalBook = await fetchBookByID(book.id);

      this.originalBk[0].inputValue = originalBook.name;
      this.originalBk[1].inputValue = originalBook.authors.filter(
        (a) => a.authorTypeId === 1
      )[0].name;

      let fromYear = originalBook.fromyear[0].name;
      let toYear = originalBook.toyear[0].name;
      fromYear = fromYear === toYear ? fromYear : fromYear + " - " + toYear;

      this.originalBk[2].inputValue = fromYear;
      this.originalBk[3].inputValue = originalBook.places[0].name;

      this.originalBk[4].inputValue = originalBook.addnames
        .map((n) => n.name)
        .join("\n");

      this.originalBk[5].inputValue = originalBook.authors
        .filter((a) => a.authorTypeId == 2)
        .map((a) => a.name)
        .join("\n");

      this.hasOriginalBk = true;
    },
  },
};
</script>

<style lang="scss">
$bg-color2: #f7f7f7;
$bg-color5: #f4f4f4;
.main-books-list-info {
  width: -webkit-fill-available;
  display: flex;
  flex-direction: column;
}
.book-info-container {
  display: flex;
  flex-direction: column;
  padding: 0px 10px 0px 10px;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  padding: 34px 20px 20px;
  flex-grow: 1;
  input.input-border.filled + label {
    margin-bottom: 20px !important;
  }
  input.input-border.filled + label span {
    height: 14px;
    line-height: 14px;
    font-size: 10px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.3);
  }
  .input-border.filled:focus + label span {
    color: var(--custom-color1);
  }
}
.input-data {
  display: flex;
  border: none;
  border-bottom: 1px solid #a0a1b2;
  background: none;
  width: -webkit-fill-available;
}
.inputs-data-bloke {
  resize: none;
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  line-height: 20px;
}
.origin-data {
  border: 1px solid #a0a1b2;
  margin-bottom: 15px;
  // line-height: 5px;
  padding: 1px 13px;
}
.origin-val {
  font-weight: bold;
  white-space: pre;
  line-height: normal;
}
.change-book-settings {
  width: auto;
  padding: 0 10px;
  margin: 14px 0;
}
.change-book-settings-block {
  display: flex;
  // margin-top: auto;
  height: 60px;
  background-color: $bg-color5;
  border-top: 1px solid #dedede;
  height: 60px;
  background-color: $bg-color5;
  border: 1px solid #dedede;
  padding: 0 20px;
  justify-content: space-between;
}
.text-area-container {
  p {
    margin: 0;
    font-weight: 300;
    color: #a7a7a7;
    font-size: 12px;
  }
  .inputs-data-bloke {
    background-color: $bg-color2;
    margin-top: 3px;
    border: 1px solid #afafaf;
    margin-bottom: 26px;
  }
}
.main-menu .row {
  margin-bottom: 10px;
}
</style>
